export default function CloseRequestIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25 9.75H10V15H10.75M19 10.5C19 15.4706 14.9706 19.5 10 19.5C5.02944 19.5 1 15.4706 1 10.5C1 5.52944 5.02944 1.5 10 1.5C14.9706 1.5 19 5.52944 19 10.5Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.5C10.6213 7.5 11.125 6.99632 11.125 6.375C11.125 5.75368 10.6213 5.25 10 5.25C9.37868 5.25 8.875 5.75368 8.875 6.375C8.875 6.99632 9.37868 7.5 10 7.5Z"
        fill="#B721FF"
      />
    </svg>
  );
}
